<div class="widget-icon" cdkDrag [cdkDragData]="data">
    <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">
        {{data.icon}}
    </mat-icon>
    <p>IP</p>
</div>